<template>
  <v-card flat class="ma-0 pa-0">
    <v-parallax class="hero-image" :height="$vuetify.breakpoint.mobile ? 200 : 400" src="@/assets/images/ifpi-start-hero.jpg">
      <v-card-title class="display-2 mb-1">{{ $t('login.title') }}</v-card-title>
    </v-parallax>
    <v-card-title></v-card-title>
    <v-card-text>
      <v-btn color="secondary" @click="login(null)" class="t-login-btn">{{ $t('login.btn-email-text') }}</v-btn>
      <v-btn color="secondary" @click="login('sms')" class="ml-6 t-login-btn">{{ $t('login.btn-sms-text') }}</v-btn>
    </v-card-text>
    <v-card-text class="body-1"><p v-html="$t('login.info')"></p></v-card-text>
  </v-card>
</template>

<script>

export default {
  name: 'Login',

  methods: {
    login(connType) {
      this.$auth.loginWithRedirect(connType)
    },
  }

}
</script>

<style>

</style>